import { IUpdateAutomationPayload } from 'modules/settings/models';
import API from 'services/api';

export const updateAutomation = ({
  automationId,
  payload,
}: {
  automationId: number;
  payload: IUpdateAutomationPayload;
}) => API.put(`api/automation/${automationId}`, payload);
